import React, { useEffect, useState } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { TextInput } from '../../../Helpers/Inputs';
import { setBasicInfo } from '../../../../sessionStorage';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { object, string } from 'yup';
import { Button, SvgIcon, CircularProgress, makeStyles } from "@material-ui/core";
import Appointment from '../../../../icons/apppointment.svg';
import { InputMaskPhone } from "../../../Helpers/Formatters";
import TermScheduler from './TermScheduler';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined';
import { postApp } from '../../Common/Helpers/PostApp';
import { saveSessionEvent } from "../../../../session";
import PropTypes from 'prop-types';
import { ComplimentaryReview, DisclosureText } from '../../Common/Appointment/CustomAppointmentData';

const useStyles = makeStyles((theme) => ({
  privacySell: {
    fontSize: '10px',
    marginBottom: '12px',
  },
  disclosureText: {
    fontSize: '14px',
    lineHeight: '1.25rem',
    '& a': {
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.main,
      },
      '&:focus': {
        color: theme.palette.primary.main,
      },
    }
  }
}));
export default function ScheduleForm(props) {

  const classes = useStyles();
  const isSelectOrTalk = props.quoter.isSelectOrTalk;
  const [postingApp, setPosting] = useState(false);

  const { register, errors, handleSubmit, setValue } = useForm({
    validationSchema: ScheduleForm.ValidationSchema(),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  // manually call setValue for fields that don't play nice with react-hook-form register
  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
  };

  useEffect(() => {
    let email = props.formState.email, firstName = props.formState.firstName, lastName = props.formState.lastName;
    if (props.basicInfo && props.basicInfo.firstName !== '') {
      firstName = props.basicInfo.firstName;
    }
    if (props.basicInfo && props.basicInfo.lastName !== '') {
      lastName = props.basicInfo.lastName;
    }
    if (props.basicInfo && props.basicInfo.email !== '') {
      email = props.basicInfo.email;
    }
    props.setMultiField(firstName, lastName, email);
  }, []);

  useEffect(() => {
    // Save data into basic info when updated
    if (props.basicInfo.firstName !== props.formState.firstName) {
      props.basicInfo.firstName = props.formState.firstName;
    }
    if (props.basicInfo.lastName !== props.formState.lastName) {
      props.basicInfo.lastName = props.formState.lastName;
    }
    if (props.basicInfo.email !== props.formState.email) {
      props.basicInfo.email = props.formState.email;
    }
    setBasicInfo(props.basicInfo);

  }, [props.formState.firstName, props.formState.lastName, props.formState.email]);

  useEffect(() => {
    // manually register fields for validation that don't play nice with react-hook-form register
    register({ name: 'firstName' });
    setValue('firstName', props.formState.firstName);

    register({ name: 'lastName' });
    setValue('lastName', props.formState.lastName);

    register({ name: 'email' });
    setValue('email', props.formState.email);

    register({ name: 'phone' });
    setValue('phone', props.formState.phone);

    register({ name: 'specificAppt' });
    setValue('specificAppt', props.formState.specificAppt);

    register({ name: 'timeZone' });
    setValue('timeZone', props.formState.timeZone);

    register({ name: 'specificApptDate' });
    setValue('specificApptDate', props.formState.specificApptDate);

    register({ name: 'specificApptTime' });
    setValue('specificApptTime', props.formState.specificApptTime);

  }, [register]);

  const submitPostApp = () => {
    setPosting(true);

    postApp(props.basicInfo, props.quoter, props.sessionStorageHealthData, props.formState, props.quoter.termLength).then((data) => {
      if (data.success) {
        saveSessionEvent(true);
        props.onNext();
      } else {
        setPosting(false);
      }
    }).finally(() => {
      setPosting(false);
    });
  };

  return (
    <React.Fragment>
      <Row className="justify-content-center text-center mt-2 hide-class">
        <SvgIcon component={Appointment} className="icons" color="primary" fontSize="large"/>
      </Row>
      <Row className="justify-content-center pt-2  appointment-heading pb-1">
        <h4>Complete Your Request</h4>
      </Row>
      <Row className='mx-auto appointment-text'>
        {isSelectOrTalk === "contactSpecialist" ?
          <div>A licensed insurance professional will help select the best coverage option for you. The quoting process
            is simple and the application typically takes 15 minutes to submit.</div>
          :
          <div>We make it quick and easy to start the approval process for your new life insurance policy.
            There’s no paper-work or face-to-face meetings. Simply provide your contact information and one of our dedicated licensed insurance specialists will review your coverage details and complete your application over the phone with you. The call is confidential, hassle-free and takes less than 15 minutes.
            As part of our commitment to your privacy and 100% satisfaction, there’s no payment due until the policy is approved and you have agreed to activate the coverage.
          </div>
        }
        <div>{ComplimentaryReview.subText}</div>
      </Row>
      <Form onSubmit={handleSubmit(submitPostApp)} className='mt-3'>
        <Row>
          <Col md={6}>
            <Form.Group>
              <TextInput
                name="firstName"
                id="firstName"
                label="First Name"
                value={props.formState.firstName}
                errors={errors && errors.firstName}
                inputRef={register}
                onChange={(e) => handleValueChange('firstName', e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <TextInput
                name="lastName"
                id="lastName"
                label="Last Name"
                value={props.formState.lastName}
                errors={errors && errors.lastName}
                inputRef={register}
                onChange={(e) => handleValueChange('lastName', e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group>
          <TextInput
            name="email"
            id="email"
            label="Email"
            value={props.formState.email}
            errors={errors && errors.email}
            inputRef={register}
            onChange={(e) => handleValueChange('email', e.target.value)}
          />
        </Form.Group>
        <div>
          <Form.Group className="mb-1">
            <TextInput
              name="phone"
              id="phone"
              value={props.formState.phone}
              onChange={(e) => handleValueChange('phone', e.target.value)}
              label="Phone Number"
              inputRef={register}
              errors={errors.phone}
              InputProps={{
                inputComponent: InputMaskPhone,
              }}
            />
          </Form.Group>
          <div className={`${classes.privacySell} d-flex justify-content-center mt-3`}>
            Your information is private and secure, and is never sold to a third party.
          </div>
        </div>
        <TermScheduler setValue={setValue} errors={errors} register={register} formState={props.formState}
                       onFieldChange={(field, value) => props.onFieldChange(field, value)}/>
        {postingApp ? (
          <Row className="mt-4">
            <Col>
              <div className="submit-loading-container text-center">
                <CircularProgress/>
              </div>
            </Col>
          </Row>
        ) : (
          <Row className="mt-4">
            <Col className="text-left pb-3 btn-back">
              <Button variant="outlined" className='w-100' size="medium" color="primary" onClick={props.onBack}>
                BACK
              </Button>
            </Col>
            <Col className="text-right pb-3">
              <Button variant="contained" className='w-100' size="medium" color="primary" type="submit">
                SUBMIT
              </Button>
            </Col>
          </Row>
        )}
      </Form>
      <div className={classes.disclosureText} dangerouslySetInnerHTML={{ __html: DisclosureText }} />
    </React.Fragment>
  );
}

ScheduleForm.propTypes = {
  quoter: PropTypes.object,
  formState: PropTypes.object,
  basicInfo: PropTypes.object,
  onFieldChange: PropTypes.func,
  setMultiField: PropTypes.func,
  sessionStorageHealthData: PropTypes.object,
  onBack: PropTypes.func,
};

ScheduleForm.ValidationSchema = () => {
  return object().shape({
    firstName: string().required('First Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid First Name'),
    lastName: string().required('Last Name is required.').matches(/^[a-zA-Z]+$/, 'Invalid Last Name'),
    email: string()
      .email('Email Address must be valid.')
      .required('Email Address is required.'),
    phone: string()
      .required('Phone number is required.')
      .matches(/^\(\d{3}\)\s\d{3}-\d{4}$/, 'Phone must be formatted as (123) 456-7890'),
    specificAppt: string()
      .required('Select an appointment option.'),
    timeZone: string().transform(emptyStringToUndefined).when('specificAppt', {
      is: 'schedule',
      then: string().required("Timezone is required."),
      otherwise: string().notRequired(),
    }),
    specificApptDate: string().transform(emptyStringToUndefined).when('specificAppt', {
      is: 'schedule',
      then: string().required("Appointment date is required."),
      otherwise: string().notRequired(),
    }),
    specificApptTime: string()
      .when(['specificApptDate', 'timeZone'], {
        is: (specificApptDate, timeZone) => specificApptDate && timeZone,
        then: string().required('Time of call is required.'),
        otherwise: string().notRequired(),
      }),
  });
};



// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/QuoterComponents/ScheduleForm.js